export const formatJSONContent = (contentJSON: string) => {
    try {
        return JSON.stringify(JSON.parse(contentJSON), null, '\t');
    } catch (_error) {
        return contentJSON;
    }
};
